<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { ref, watch } from "vue"
import { useRoute, useRouter } from "vue-router"

// ================================
// COMPOSABLES
// ================================
const route = useRoute()
const router = useRouter()

// ================================
// STATE
// ================================
/** Vue courante affichée (login, forget-password, first-login, multi-company) */
const view = ref(
    (Array.isArray(route.query.view)
        ? route.query.view[0]
        : route.query.view) || "login"
)

// ================================
// WATCHERS
// ================================
watch(
    () => route.query.view,
    (newView) => {
        view.value = (Array.isArray(newView) ? newView[0] : newView) ?? "login"
    }
)

// ================================
// INTERACTIONS
// ================================
/**
 * Change la vue affichée et met à jour l'URL.
 * @param newView - Identifiant de la vue (login, forget-password, first-login, multi-company)
 */
function onUpdateView(newView: string): void {
    view.value = newView
    router.push({
        path: route.path,
        query: newView === "login" ? {} : { view: newView },
    })
}
</script>

<template>
    <!-- ================================ -->
    <!-- PAGE CONTAINER -->
    <!-- ================================ -->
    <div class="page page-login flex justify-center items-center min-h-screen">
        <div class="w-full max-w-2xl mx-4">
            <FormAuthLogin
                v-if="view === 'login'"
                @click:password="onUpdateView('forget-password')"
                class="p-8"
            />
            <FormAuthForgetPassword
                v-else-if="view === 'forget-password'"
                @click:login="onUpdateView('login')"
                class="p-8"
            />
            <FormAuthFirstLogin
                v-else-if="view === 'first-login'"
                @click:login="onUpdateView('login')"
                class="p-8"
            />
            <FormAuthMultiCompany
                v-else-if="view === 'multi-company'"
                @click:login="onUpdateView('login')"
                class="p-8"
            />
        </div>
    </div>
</template>
